import { IRecord, IRecordType } from 'annotation-tools/utils';

// immutable object generator
export const ICsv = IRecord<CsvType>({
  id: 0,
  name: ''
});

// immutable type
export type ICsvType = IRecordType<CsvType>;

type CsvType = {
  id: number;
  name: string;
};
